import React, { useState, useEffect } from 'react';
import supabase from '../components/supabaseClient';
import { useNavigate } from 'react-router-dom';
import Modal from '../components/Modal';

function UpdatePassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        navigate('/');
      }
    };
    checkAuth();
  }, [navigate]);

  const handleClose = () => {
    setIsOpen(false);
    navigate('/');
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setMessage('');

    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match.');
      setIsSuccess(false);
      return;
    }

    if (newPassword.length < 6) {
      setMessage('Password must be at least 6 characters.');
      setIsSuccess(false);
      return;
    }

    setIsLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({ password: newPassword });
      if (error) throw error;
      sessionStorage.setItem('password_updated', 'true');
      navigate('/');
    } catch (error) {
      setMessage('Error: ' + error.message);
      setIsSuccess(false);
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Update Password">
      <div className="form-container">
        <p style={{ marginBottom: '1rem', color: '#666', fontSize: '14px' }}>
          Enter your new password below.
        </p>
        <form onSubmit={handleUpdatePassword}>
          <div className="form-input">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={6}
              disabled={isLoading}
            />
          </div>
          <div className="form-input">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={6}
              disabled={isLoading}
            />
          </div>
          {message && (
            <p className="error-message" style={isSuccess ? { color: '#16a34a', backgroundColor: '#f0fdf4', borderColor: '#bbf7d0' } : {}}>
              {message}
            </p>
          )}
          <button
            type="submit"
            className="btn btn-primary btn-full"
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Update Password'}
          </button>
        </form>
      </div>
    </Modal>
  );
}

export default UpdatePassword;
